import React from 'react'
import { Trash2 } from 'lucide-react'
import { Button } from '../ui/button'
import LoadingSpinner from './LoadingSpinner'

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  confirmVariant = "destructive",
  icon: IconComponent = Trash2,
  iconColor = "var(--danger)",
  iconBgColor = "color-mix(in srgb, var(--danger) 12%, transparent)"
}) => {
  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) {
      onClose()
    }
  }

  return (
    <div
      className="modal-backdrop"
      onClick={handleBackdropClick}
    >
      <div className="modal" style={{ maxWidth: '28rem' }} onClick={(e) => e.stopPropagation()}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '3rem',
          height: '3rem',
          margin: '0 auto 1rem',
          background: iconBgColor,
          borderRadius: '50%',
        }}>
          <IconComponent style={{ width: '1.5rem', height: '1.5rem', color: iconColor }} />
        </div>

        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <h3 className="font-semibold" style={{ fontSize: '1.125rem', marginBottom: '0.5rem' }}>
            {title}
          </h3>
          <div className="text-muted">
            {message}
          </div>
        </div>

        <div className="flex gap-3 justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="sm" className="mr-2" />
                Processing...
              </>
            ) : (
              <>
                <IconComponent style={{ width: '1rem', height: '1rem', marginRight: '0.5rem' }} />
                {confirmText}
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal
